"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Test if we're operating in a browser environment.
 *
 * @return {boolean} true if we are, false if we're not.
 */
var isBrowser = function isBrowser() {
  return typeof window !== "undefined";
};

exports.default = isBrowser;
//# sourceMappingURL=isBrowser.js.map